import {Button, Paper, Typography} from "@mui/material";
import styled from "styled-components";
import {zIndex} from "../theme/tokens";

type Props = {
	message: string,
	actionOneMessage?: string,
	onActionOneClick?: () => void,
	actionTwoMessage?: string,
	onActionTwoClick?: () => void,
}

let Root = styled(Paper)`
	position: static;
	display: flex;
	width: 100%;
	padding: 8px;
	padding-left: 16px;
	padding-top: 10px;
	flex-direction: row;
	justify-content: space-between;
	/* Below the modal layer on purpose so a banner can't bleed through a dialog scrim (tokens.zIndex). */
	z-index: ${zIndex.banner};
	border-bottom-width: 1px;
	border-bottom-color: rgba(181,181,181,0.48);
	border-bottom-style: solid;
	align-items: center;
`
let AlertsContainer = styled.div`
	display: flex;
	justify-content: space-between;
`

export default function Banner({message, onActionOneClick, actionOneMessage, onActionTwoClick, actionTwoMessage}: Props) {
	return (
		<Root elevation={0} square>
			<Typography variant={"body2"} >{message}</Typography>
			<AlertsContainer>
				<Button
					disableElevation
					variant={"text"}
					color={"primary"}
					onClick={() => {
						if (onActionOneClick != null)
							onActionOneClick();
					}}
				>{actionOneMessage}</Button>
				{actionTwoMessage &&
				<Button
					disableElevation
					variant={"text"}
					color={"primary"}
					onClick={() => {
						if (onActionTwoClick != null)
							onActionTwoClick();
					}}
				>{actionTwoMessage}</Button>
				}
			</AlertsContainer>
		</Root>
	);
};